export default __webpack_public_path__ + "static/media/NameIcon.cec63b32.svg";